import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { RingaLogo } from '../brand/RingaLogo';
import { api } from '../lib/api';
import { logout } from '../lib/auth';
import { fmtDay, validityLabel } from '../lib/format';

interface Item {
  slug: string;
  title: string;
  clientName: string;
  expiresAt: string;
  expired: boolean;
  acceptedAt: string | null;
}

export const ClientHome = ({ email }: { email: string }) => {
  const [items, setItems] = useState<Item[] | null>(null);

  useEffect(() => {
    api<{ proposals: Item[] }>('/api/me/proposals').then((r) => setItems(r.proposals));
  }, []);

  return (
    <div className="home">
      <header className="home-top">
        <RingaLogo className="vbar-logo" />
        <div className="home-me">
          <span>{email}</span>
          <button className="btn btn-ghost btn-sm" onClick={logout}>
            Sair
          </button>
        </div>
      </header>
      <main className="home-in">
        <p className="kick enter">Suas propostas</p>
        <h1 className="enter" style={{ ['--d' as string]: '.06s', marginTop: '.8rem' }}>
          O que a Ringa <span className="l2">preparou para você.</span>
        </h1>
        {!items ? (
          <div className="center" style={{ minHeight: 200 }}>
            <div className="spinner" />
          </div>
        ) : items.length === 0 ? (
          <p className="muted" style={{ marginTop: '2rem' }}>
            Nenhuma proposta liberada para este e-mail no momento.
          </p>
        ) : (
          <div className="home-list">
            {items.map((p, i) => (
              <Link key={p.slug} to={`/p/${p.slug}`} className="home-card panel enter" style={{ ['--d' as string]: `${0.12 + i * 0.06}s` }}>
                <div>
                  <h2>{p.title}</h2>
                  <p>
                    {p.clientName} · {p.acceptedAt ? `Aceita em ${fmtDay(p.acceptedAt)}` : validityLabel(p.expiresAt, p.expired)}
                  </p>
                </div>
                <span className="arrow" aria-hidden="true">
                  →
                </span>
              </Link>
            ))}
          </div>
        )}
      </main>
      <footer className="home-foot">Ringa. A ponta de lança tecnológica da sua empresa.</footer>
    </div>
  );
};
